import React from "react";
import PropTypes from "prop-types";

const ListTableSection = ({ controls, children }) => (
  <div className="min-w-0 pt-5">
    {controls ? <div className="mb-5">{controls}</div> : null}
    {children}
  </div>
);

ListTableSection.propTypes = {
  controls: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default ListTableSection;
